import { render, staticRenderFns } from "./CorrectiveActionItem.vue?vue&type=template&id=40604a68"
import script from "./CorrectiveActionItem.vue?vue&type=script&lang=js"
export * from "./CorrectiveActionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports